import React, { useEffect, useState } from 'react';

const ReadingProgress = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const updateProgress = () => {
      // Calculate how far the user has scrolled down the page
      const currentScrollY = window.scrollY;
      
      // Calculate the total scrollable height
      // total height of the document minus the height of the viewport
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      
      if (scrollHeight) {
        setProgress(Number(((currentScrollY / scrollHeight) * 100).toFixed(2)));
      }
    };

    // Add scroll event listener
    window.addEventListener('scroll', updateProgress);
    // Initial call to set correct progress if page is loaded scrolled down
    updateProgress();

    return () => window.removeEventListener('scroll', updateProgress);
  }, []);

  return (
    <div className="fixed top-0 left-0 w-full h-1 z-50 bg-transparent">
      <div 
        className="h-full bg-primary transition-all duration-150 ease-out" 
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};

export default ReadingProgress;
